import { Action, Selector, State, type StateContext } from "@ngxs/store";
import { TokenUtils } from "@utils/token.utils";

import { Service } from "@angular/core";

import { ClearUser, SetUser } from "./user.actions";

export interface UserStateModel {
  rut: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  tenants: {
    tenantName: string;
    isAdmin: boolean;
  }[];
  isPlatformAdministrator: boolean;
}

@State<UserStateModel | null>({
  name: "User",
  defaults: {
    rut: "",
    email: "",
    firstName: "",
    lastName: "",
    fullName: "",
    tenants: [],
    isPlatformAdministrator: false,
  },
})
@Service({ autoProvided: false })
export class UserState {
  @Selector()
  static rut(state: UserStateModel) {
    return state.rut;
  }

  @Selector()
  static email(state: UserStateModel) {
    return state.email;
  }

  @Selector()
  static firstName(state: UserStateModel) {
    return state.firstName;
  }

  @Selector()
  static lastName(state: UserStateModel) {
    return state.lastName;
  }

  @Selector()
  static fullName(state: UserStateModel) {
    return state.fullName;
  }

  @Selector()
  static tenants(state: UserStateModel) {
    return state.tenants;
  }

  @Selector()
  static isPlatformAdministrator(state: UserStateModel) {
    return state.isPlatformAdministrator;
  }

  @Action(SetUser)
  setUser(ctx: StateContext<UserStateModel>, action: SetUser) {
    const tokenUtils = new TokenUtils(action.accessToken);
    ctx.patchState({
      rut: tokenUtils.getUserRut(),
      email: tokenUtils.getUserEmail(),
      firstName: tokenUtils.getUserFirstName(),
      lastName: tokenUtils.getUserLastName(),
      fullName: tokenUtils.getUserFullName(),
      tenants: (tokenUtils.getUserTenants() ?? []).map(tenant => ({
        tenantName: tenant.replace("/", ""),
        isAdmin: tokenUtils.getUserAdmin().includes(tenant.replace("/", "")),
      })),
      isPlatformAdministrator: tokenUtils.isPlatformAdministrator(),
    });
  }

  @Action(ClearUser)
  clearUser(ctx: StateContext<UserStateModel | null>) {
    ctx.setState(null);
  }
}
